import cn from 'classnames'
import React, { useCallback, useState } from 'react'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'
import { TRANSLATION_KEYS } from 'partner360/widgets/gp360Administration/translations'

import { exportGlobalFinData } from '../../helpers/exportGlobalFinData'

import styles from './ExportGlobalFinReport.module.scss'

interface IExportGlobalFinReportProps {
  globalPartnerId: string
  fYear: number
  globalPartnerName: string
}

export const ExportGlobalFinReport = ({
  globalPartnerId,
  fYear,
  globalPartnerName,
}: IExportGlobalFinReportProps) => {
  const [isLoading, setIsLoading] = useState(false)
  const onClick = useCallback(async () => {
    setIsLoading(true)
    await exportGlobalFinData(fYear, globalPartnerId, globalPartnerName)
    setIsLoading(false)
  }, [fYear, globalPartnerId, globalPartnerName])

  return (
    <Button disabled={isLoading} onClick={onClick}>
      <div className={cn({ [styles.hidden]: isLoading })}>
        <Translation text={TRANSLATION_KEYS.globalPartnerExpanded.financialsChart.export} />
      </div>

      <RenderWhen condition={isLoading}>
        <Loader dimension={{ height: 22, width: 22 }} />
      </RenderWhen>
    </Button>
  )
}
